import { z } from "zod";
export const dayPriceDefaultSchema = z.object({
    day_of_week: z.number().int().min(0).max(6),
    price_per_night_cents: z.number().int().min(0),
});
export const bulkDayPriceDefaultsSchema = z.object({
    defaults: z.array(dayPriceDefaultSchema).length(7),
});
